import React, { useContext, useState } from 'react';
import { Button, Modal } from 'antd';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import OrgHierarchySelector from '@totem/components/ui_components/widgets/hierarchySelector/orgHierarchySelector';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ObjectReference } from '@totem/types/common';
import { AWS_INSTANCES_ENDPOINT } from '@totem/utilities/endpoints';

const EMPTY_REF: ObjectReference = { id: '', name: '' };

const AssignHierarchyModal = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const { selectedInstance, activeAction, onActionClose, onRefresh } =
    useContext(AmazonWebServicesContext);
  const [organization, setOrganization] = useState<ObjectReference>(EMPTY_REF);
  const [region, setRegion] = useState<ObjectReference>(EMPTY_REF);
  const [building, setBuilding] = useState<ObjectReference>(EMPTY_REF);
  const [saving, setSaving] = useState<boolean>(false);

  if (activeAction !== 'hierarchy' || !selectedInstance) {
    return null;
  }

  const handleHierarchyChange = (
    org: ObjectReference,
    rgn: ObjectReference,
    bldg: ObjectReference,
  ) => {
    setOrganization(org);

    setRegion(rgn);

    setBuilding(bldg);
  };

  const handleSave = () => {
    setSaving(true);

    fetch(
      `${AWS_INSTANCES_ENDPOINT}/${selectedInstance.item.instance.instanceId}/hierarchy`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${getApiToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ organization, region, building }),
      },
    ).then(() => {
      setSaving(false);

      onActionClose();

      onRefresh();
    });
  };

  return (
    <Modal
      open
      title={<ModalTitle>Assign Hierarchy</ModalTitle>}
      onCancel={onActionClose}
      footer={
        <ModalFooter>
          <Button onClick={onActionClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave} loading={saving}>
            Save
          </Button>
        </ModalFooter>
      }
    >
      <p>
        Instance: <strong>{selectedInstance.name}</strong>
      </p>
      <OrgHierarchySelector
        showLabels
        labelPosition="left"
        showOrganization={permissions.internal.hasPermissions(userProfile)}
        showRegions={false}
        showBuildings
        showControlSystems={false}
        defaultOrganizationId={
          selectedInstance.hierarchyReference?.organization?.id
        }
        defaultBuildingId={selectedInstance.hierarchyReference?.building?.id}
        onChange={handleHierarchyChange}
      />
    </Modal>
  );
};

export default AssignHierarchyModal;
